import {
  FETCH_WHITELIST,
  FETCH_WHITELIST_FAIL,
  FETCH_WHITELIST_SUCCESS,
  CHANGE_WHITELIST_PAGE,
  CHANGE_WHITELIST_PAGE_SIZE,
  RELOAD_WHITELIST,
  UPDATE_WHITELIST_FILTERS
} from '../../actions/cm/whiteList';
import { DEFAULT_PAGE_SIZE } from '../../../pages/constants/cmConstants';

export const initialState = {
  list: [],
  isLoading: false,
  total: 0,
  hasError: false,
  currentPage: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  searchText: ''
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_WHITELIST:
      return {
        ...state,
        isLoading: true,
        hasError: false
      };
    case FETCH_WHITELIST_SUCCESS:
      return {
        ...state,
        list: payload.whitelistData,
        total: payload.total,
        isLoading: false,
      };
    case FETCH_WHITELIST_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true
      };
    case CHANGE_WHITELIST_PAGE:
      return {
        ...state,
        currentPage: payload,
      };
    case CHANGE_WHITELIST_PAGE_SIZE:
      return {
        ...state,
        pageSize: payload,
      };
    case RELOAD_WHITELIST:
      return {
        ...state,
      };
    case UPDATE_WHITELIST_FILTERS:
      return {
        ...state,
        searchText: payload,

        currentPage: 1
      };
    default:
      return state;
  }
}
